import { combineReducers } from 'redux';
import appReducer from '../routes/modules/app';
import currentReducer from '../routes/modules/current';
import updateDetailReducer from '../routes/routes/updateDetail/modules/updateDetail';
import edorsedApplyReducer from '../routes/routes/endorsedApply/modules/edorsedApply';
import ticketChangesReducer from '../routes/routes/ticketChanges/modules/ticketChanges';
import applySubmitReducer from '../routes/routes/applySubmit/modules/applySubmit';
import subInfoReducer from '../routes/routes/reformProcess/modules/subInfo';
import realNameVerifyReducer from '../routes/routes/realNameVerify/modules/realNameVerify';
import feeQueryReducer from '../routes/routes/feeQuery/modules/feeQuery';
import selectDateReducer from '../routes/routes/selectDate/modules/selectDate';
import changeFlightReducer from '../routes/routes/changeFlight/modules/changeFlight';
import easyLoginQueryReducer from '../routes/routes/easyLogin/modules/easyLogin';
import electronicInvoiceReducer from '../routes/routes/electronicInvoice/modules/electronicInvoice';
// import officialTicketReducer from '../routes/routes/officialTicket/modules/officialTicket';
import couponsReducer from '../routes/routes/coupon/modules/coupon';
import refundCouponsReducer from '../routes/routes/refundCoupon/modules/coupon';
import productReducer from '../routes/routes/addProductShop/modules/addProduct';
import cancelLationReducer from '../routes/routes/cancelLation/modules/cancelLation';
import changeRefundExplainReducer from '../routes/routes/changeRefundExplain/modules/changeRefundExplain';

export const makeRootReducer = asyncReducers => {
  return combineReducers({
    App: appReducer,
    current: currentReducer,
    updateDetail: updateDetailReducer,
    EdorsedApply: edorsedApplyReducer,
    ticketChange: ticketChangesReducer,
    applySubmit: applySubmitReducer,
    subInfo: subInfoReducer,
    realNameVerify: realNameVerifyReducer,
    feeQuery: feeQueryReducer,
    selectDate: selectDateReducer,
    changeFlight: changeFlightReducer,
    easyLoginQuery: easyLoginQueryReducer,
    electronicInvoice: electronicInvoiceReducer,
    // officialTicket: officialTicketReducer,
    coupons: couponsReducer,
    refundCoupons: refundCouponsReducer,
    addProductShop: productReducer,
    cancelLation: cancelLationReducer,
    changeRefundExplain: changeRefundExplainReducer,
    ...asyncReducers,
  });
};

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;
  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers.js